module.exports = __webpack_public_path__ + "img/Explorer.343b292a.png";